import React, { Component } from "react";
import {
  Collapse,
  Container,
  Navbar,
  NavbarBrand,
  NavbarToggler,
  NavItem,
  NavLink,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem
} from "reactstrap";
import { Link } from "react-router-dom";
import "./NavMenu.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export class NavMenu extends Component {
  static displayName = NavMenu.name;

  constructor(props) {
    super(props);

    this.toggleNavbar = this.toggleNavbar.bind(this);

    let environmentDisplay = "dev";
    switch (window.location.hostname) {
      case "qa.cbdpc.tech":
        environmentDisplay = "qa";
        break;
      case "app.cbdpc.tech":
        environmentDisplay = "";
        break;
      default:
        environmentDisplay = "dev";
    }

    this.state = {
      collapsed: true,
      environmentDisplay: environmentDisplay
    };
  }

  toggleNavbar() {
    this.setState({
      collapsed: !this.state.collapsed
    });
  }

  render() {
    return (
      <header>
        <Navbar
          className="navbar-expand-sm navbar-toggleable-sm ng-white border-bottom box-shadow mb-3 blueText"
          light
        >
          <Container>
            <NavbarBrand
              title={`version: ${this.props.appVersion || "N/A"}`}
              tag={Link}
              to="/"
              className="float-left"
            >
              <img src="/cbdMD_logo.png" alt="Logo" className="App-logo" />
              {this.state.environmentDisplay && (
                <span className="badge badge-danger">
                  {this.state.environmentDisplay} environment
                </span>
              )}
            </NavbarBrand>
            <NavbarToggler onClick={this.toggleNavbar} className="mr-2" />
            <Collapse
              className="d-sm-inline-flex flex-sm-row-reverse"
              isOpen={!this.state.collapsed}
              navbar
            >
              <ul className="navbar-nav flex-grow">
                {this.props.currentUser && (
                  <React.Fragment>
                    {" "}
                    <NavItem>
                      <NavLink tag={Link} className="text-dark" to="/">
                        Home
                      </NavLink>
                    </NavItem>
                    {(this.props.currentUser.isWarehouseAdmin ||
                      this.props.currentUser.isMaintenanceAdmin) && (
                      <NavItem>
                        <NavLink tag={Link} className="text-dark" to="/admin">
                          Admin
                        </NavLink>
                      </NavItem>
                    )}
                        <NavItem>
                            <UncontrolledDropdown
                                style={{ paddingLeft: "0" }}
                                tag={"ul"}
                                nav
                                inNavbar
                            >
                                <DropdownToggle nav caret className="text-dark">
                                    COA
                                </DropdownToggle>
                                <DropdownMenu right>
                                    <DropdownItem>
                                        <NavItem>
                                            <NavLink
                                                tag={Link}
                                                className="text-dark"
                                                to="/coa"
                                            >
                                                Dashboard
                                            </NavLink>
                                        </NavItem>
                                    </DropdownItem>
                                    <DropdownItem>
                                        <NavItem>
                                            <NavLink
                                                tag={Link}
                                                className="text-dark"
                                                to="/requestlog"
                                            >
                                                Request Log
                                            </NavLink>
                                        </NavItem>
                                    </DropdownItem>
                                </DropdownMenu>
                            </UncontrolledDropdown>
                    </NavItem>
                    {this.props.currentUser.isPlanner && (
                      <NavItem>
                        <NavLink
                          tag={Link}
                          className="text-dark"
                          to="/production_planning"
                        >
                          Planning
                        </NavLink>
                      </NavItem>
                    )}
                    {(this.props.currentUser.isWarehouseAdmin ||
                      this.props.currentUser.isMaintenanceAdmin) && (
                      <NavItem>
                        <UncontrolledDropdown
                          style={{ paddingLeft: "0" }}
                          tag={"ul"}
                          nav
                          inNavbar
                        >
                          <DropdownToggle nav caret className="text-dark">
                            Reports
                          </DropdownToggle>
                          <DropdownMenu right>
                            <DropdownItem>
                              <NavItem>
                                <NavLink
                                  tag={Link}
                                  className="text-dark"
                                  to="/sales_report"
                                >
                                  Sales
                                </NavLink>
                              </NavItem>
                            </DropdownItem>
                            <DropdownItem>
                              <NavItem>
                                <NavLink
                                  tag={Link}
                                  className="text-dark"
                                  to="/production_metrics_report"
                                >
                                  Production Metrics
                                </NavLink>
                              </NavItem>
                            </DropdownItem>
                          </DropdownMenu>
                        </UncontrolledDropdown>
                      </NavItem>
                    )}
                    {!window.TurnOffCycleCount &&
                      this.props.currentUser.isWarehouseUser && (
                        <NavItem>
                          <UncontrolledDropdown
                            style={{ paddingLeft: "0" }}
                            tag={"ul"}
                            nav
                            inNavbar
                          >
                            <DropdownToggle nav caret className="text-dark">
                              Warehouse
                            </DropdownToggle>
                            <DropdownMenu right>
                              <DropdownItem>
                                <NavItem>
                                  <NavLink
                                    tag={Link}
                                    className="text-dark"
                                    to="/inventory_cycle_count"
                                  >
                                    Inventory Cycle Count
                                  </NavLink>
                                </NavItem>
                              </DropdownItem>
                              <DropdownItem>
                                <NavItem>
                                  <NavLink
                                    tag={Link}
                                    className="text-dark"
                                    to="/current_inventory_totals"
                                  >
                                    Current Inventory Totals
                                  </NavLink>
                                </NavItem>
                              </DropdownItem>
                              <DropdownItem>
                                <NavItem>
                                  <NavLink
                                    tag={Link}
                                    className="text-dark"
                                    to="/cycle_count_change_history"
                                  >
                                    Cycle Count Change History
                                  </NavLink>
                                </NavItem>
                              </DropdownItem>
                            </DropdownMenu>
                          </UncontrolledDropdown>
                        </NavItem>
                      )}
                    {this.props.currentUser.isMaintenanceUser && (
                      <NavItem>
                        <UncontrolledDropdown
                          style={{ paddingLeft: "0" }}
                          tag={"ul"}
                          nav
                          inNavbar
                        >
                          <DropdownToggle nav caret className="text-dark">
                            Equipment
                          </DropdownToggle>
                          <DropdownMenu right>
                            <DropdownItem>
                              <NavItem>
                                <NavLink
                                  tag={Link}
                                  className="text-dark"
                                  to="/equipment_dashboard"
                                >
                                  Dashboard
                                </NavLink>
                              </NavItem>
                            </DropdownItem>
                            <DropdownItem>
                              <NavItem>
                                <NavLink
                                  tag={Link}
                                  className="text-dark"
                                  to="/equipment"
                                >
                                  Equipment
                                </NavLink>
                              </NavItem>
                            </DropdownItem>
                            <DropdownItem>
                              <NavItem>
                                <NavLink
                                  tag={Link}
                                  className="text-dark"
                                  to="/equipment_maintenance_records"
                                >
                                  Maintenance Records
                                </NavLink>
                              </NavItem>
                            </DropdownItem>
                            <DropdownItem>
                              <NavItem>
                                <NavLink
                                  tag={Link}
                                  className="text-dark"
                                  to="/equipment_calibration_records"
                                >
                                  Calibration Records
                                </NavLink>
                              </NavItem>
                            </DropdownItem>
                          </DropdownMenu>
                        </UncontrolledDropdown>
                      </NavItem>
                    )}
                    {this.props.currentUser.isPlanner && (
                      <NavItem>
                        <UncontrolledDropdown
                          style={{ paddingLeft: "0" }}
                          tag={"ul"}
                          nav
                          inNavbar
                        >
                          <DropdownToggle nav caret className="text-dark">
                            Uploads
                          </DropdownToggle>
                          <DropdownMenu right>
                            <DropdownItem>
                              <NavItem>
                                <NavLink
                                  tag={Link}
                                  className="text-dark"
                                  to="/product_upload"
                                >
                                  Product Upload
                                </NavLink>
                              </NavItem>
                            </DropdownItem>
                            <DropdownItem>
                              <NavItem>
                                <NavLink
                                  tag={Link}
                                  className="text-dark"
                                  to="/production_summary"
                                >
                                  Production Daily Upload
                                </NavLink>
                              </NavItem>
                            </DropdownItem>
                            <DropdownItem>
                              <NavItem>
                                <NavLink
                                  tag={Link}
                                  className="text-dark"
                                  to="/sales_summary"
                                >
                                  Shipping Daily Upload
                                </NavLink>
                              </NavItem>
                            </DropdownItem>
                          </DropdownMenu>
                        </UncontrolledDropdown>
                      </NavItem>
                    )}
                    <NavItem>
                      <UncontrolledDropdown
                        style={{ paddingLeft: "0" }}
                        tag={"ul"}
                        nav
                        inNavbar
                      >
                        <DropdownToggle nav caret className="text-dark">
                          Hi {this.props.currentUser.firstName}{" "}
                          {this.props.impersonating && (
                            <FontAwesomeIcon
                              icon="theater-masks"
                              className="cbdmdBlueText"
                              title={"Impersonating"}
                            />
                          )}
                        </DropdownToggle>
                        <DropdownMenu right>
                          {this.props.impersonating && (
                            <DropdownItem>
                              <NavItem>
                                <NavLink
                                  tag={Link}
                                  className="text-dark"
                                  onClick={() =>
                                    this.props.clearImpersonation()
                                  }
                                  title={`Stop Impersonating`}
                                  to="/"
                                >
                                  <FontAwesomeIcon icon="theater-masks" />
                                  <span className="ml-2">
                                    Stop Impersonating
                                  </span>
                                </NavLink>
                              </NavItem>
                            </DropdownItem>
                          )}
                          <DropdownItem>
                            <NavItem>
                              <NavLink
                                tag={Link}
                                className="text-dark"
                                onClick={() => this.props.logoff()}
                                to="/"
                              >
                                <FontAwesomeIcon
                                  icon="sign-out-alt"
                                  className="ml-1 mt-0 mb-0 mr-2 pointer"
                                  title="Sign Out"
                                />{" "}
                                Logoff
                              </NavLink>
                            </NavItem>
                          </DropdownItem>
                        </DropdownMenu>
                      </UncontrolledDropdown>
                    </NavItem>
                  </React.Fragment>
                )}
                {!this.props.currentUser && (
                  <NavItem>
                    <NavLink tag={Link} className="text-dark" to="/login">
                      Login
                    </NavLink>
                  </NavItem>
                )}
              </ul>
            </Collapse>
          </Container>
        </Navbar>
      </header>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/NavMenu.js